export const changePasswordPathUri = '/change-password';
